import { useState, useEffect } from "react";

const useJason = (id) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    
     document.getElementById(id).then((res) => setData(res.innerHTML))
  }, [id]);

  return [data];
};

export default useJason;